import { render, staticRenderFns } from "./InformationCardNew.vue?vue&type=template&id=017ec2de&scoped=true"
import script from "./InformationCardNew.vue?vue&type=script&lang=ts"
export * from "./InformationCardNew.vue?vue&type=script&lang=ts"
import style0 from "./InformationCardNew.vue?vue&type=style&index=0&id=017ec2de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ec2de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017ec2de')) {
      api.createRecord('017ec2de', component.options)
    } else {
      api.reload('017ec2de', component.options)
    }
    module.hot.accept("./InformationCardNew.vue?vue&type=template&id=017ec2de&scoped=true", function () {
      api.rerender('017ec2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inforationCards/InformationCardNew.vue"
export default component.exports